import { useSelector } from "react-redux"
import { useMemo } from 'react'

const useQuoteFunnelOrderedQuestions = () => {
    const {
        quote_funnel_questions,
    } = useSelector(state => ({
        quote_funnel_questions: state.QuoteFunnelAnswersAgentProfileReducer.quote_funnel_questions,
    }))

    const {questions, page_groups} = useMemo(() => {
        const sort_by_order = (a, b) => a.order - b.order;
        const page_groups = (quote_funnel_questions?.page_groups || []).sort(sort_by_order)
            .map((page_group, pg_idx) => ({
                ...page_group,
                pages: (page_group?.pages || []).sort(sort_by_order)
                    .map((page, p_idx) => ({
                        ...page,
                        question_groups: (page?.question_groups || []).sort(sort_by_order)
                            .map((question_group, qg_idx) => ({
                                ...question_group,
                                questions: (question_group?.questions || []).sort(sort_by_order)
                                    .map(q => ({
                                        ...q,
                                        page_group_index: pg_idx,
                                        page_index: p_idx,
                                        question_group_index: qg_idx
                                    }))
                            }))
                    }))
            }))
        const questions = page_groups.flatMap(page_group => page_group?.pages.flatMap(page => page.question_groups?.flatMap(question_group => question_group?.questions)))

        return { questions, page_groups };
    }, [quote_funnel_questions])

    return [questions, page_groups];
}

export default useQuoteFunnelOrderedQuestions;
